import { createContext } from 'react';

export interface InputGroupContextType {
  disabled: boolean;
}

export const InputGroupContext = createContext<InputGroupContextType>({
  disabled: false,
});
